//MARK: Done
export const REPORT = {
  REPORT: {
    RAW: "report/raw",
    AGGREGATE: "report/aggregate",
    INCIDENT: "report/incident",
    DATA: {
      UPTIME: "report/data/uptime",
      UPTIME_AUDIT: "report/data/uptime/audit",
      USAGE: {
        AGGREGATE: "report/data/usage/aggregate",
        BASIC: "report/data/usage/basic",
        AUDIT: "report/data/usage/audit",
      },
    },
    ALERTS: "report/alerts",
    ALERT_DETAILS: "report/alert/details",
    VIEW_GENERATED: "report/view/generated",
    SCHEDULED: {
      ADD: "report/add/scheduled",
      UPDATE: "report/update/scheduled",
      DELETE: "report/delete/scheduled",
      PAGE: "report/page/scheduled",
    },
  },
};
